<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-blog m-blog__list"
    >
        <y-container
            v-for="(rogue, index) in rogues"
            :key="`${rogue.name}-${index}-container`"
            :fluid="rogue.name.includes('awards')"
            :class="rogue.name.includes('awards') ? 'px-0' : ''"
        >
            <template v-if="rogue.kind === 'block'">
                <component
                    :is="rogue.slug"
                    v-if="rogue.show"
                    :key="`${rogue.slug}-${rogue.kind}-${index}`"
                    v-bind="rogue.props"
                    v-on="rogue.listeners"
                />
            </template>

            <template v-else>
                <y-rogue-wrapper
                    v-if="rogue.show"
                    :key="`${rogue.slug}-${rogue.type}-${index}`"
                    :name="rogue.slug"
                    :type="rogue.type"
                    v-bind="rogue.props"
                    v-on="rogue.listeners"
                />
                <template v-if="rogue.name === 'List Wrapper - blog' && (paginationModel.previous_page_url || paginationModel.next_page_url)">
                    <div class="d-flex justify-content-center m-blog__list__pager">
                        <y-pagination
                            key="normal"
                            size="normal"
                            :last-page="paginationModel.last_page"
                            color="primary"
                        />
                    </div>
                </template>
            </template>
        </y-container>
    </div>
</template>
<script>
    import { YPagination } from '@components';
    import PageMixin from '@nodes/mixins/Page';
    import YBlogGrid from '@blocks/BlogGrid/Index.vue';

    export default {
        name: 'BlogList',

        components: {
            YBlogGrid,
            YPagination,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                paginationModel: null,
                filterPost     : null,
                pageTitle      : this.$t('blog.title'),
                rogues         : [
                    {
                        kind: 'block',
                        name: 'BlogCard Grid - latest',
                        slug: 'y-blog-grid',
                        show: true,
                    },
                    {
                        name : 'Section Title - blog',
                        slug : 'sectionTitle',
                        type : 'standard',
                        show : true,
                        props: {
                            class: 'mt-4 mb-4',
                            title: this.$t('blog.category'),
                        },
                    },
                    {
                        name : 'List Wrapper - category',
                        slug : 'listWrapper',
                        type : 'oneLine',
                        show : true,
                        props: {
                            class    : 'm-blog__list__category',
                            limit    : 9,
                            height   : '83px',
                            component: {
                                tag   : 'router-link',
                                name  : 'YCard',
                                type  : 'banner',
                                height: '83px',
                            },
                        },
                    },
                    {
                        name : 'List Wrapper - blog',
                        slug : 'listWrapper',
                        type : 'grid',
                        show : true,
                        props: {
                            class    : 'mb-14 m-blog__list-post',
                            limit    : 9,
                            component: {
                                classes     : 'mt-5',
                                name        : 'YBlogCard',
                                type        : 'Picture',
                                imageVersion: 'main',
                            },
                            col: {
                                xs: '12',
                                md: '4',
                            },
                        },
                    },
                ],
            };
        },

        methods: {
            /**
             * Set rogue props data
             *
             * @param {string} name - rogue name
             * @param {*} data -prop data
             */
            setProp(name, data) {
                const find = this.rogues.find((item) => item.name === name);
                const index = this.rogues.findIndex((item) => item.name === name);

                this.rogues[index] = { ...find, props: { ...find.props, ...data } };
            },

            /**
             * Set rogue showing status
             *
             * @param {string} name - rogue name
             * @param {*} status - status
             */
            setShow(name, status) {
                const find = this.rogues.find((item) => item.name === name);
                const index = this.rogues.findIndex((item) => item.name === name);

                this.rogues[index] = { ...find, show: status };
            },

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * Fetch home data
             *
             * @returns {Promise}
             */
            fetch() {
                const posts = this.$services.Content.postList({
                    type     : 'blog',
                    including: ['id', 'title', 'image', 'synopsis', 'published_at', 'publisher', 'tagging_labels:tags', 'url_encode', 'slug'],
                    locale   : this.$i18n.locale,
                    paginated: 1,
                    tagging  : this.$route.params.url_encode,
                    page     : this.$route.query.page || 1,
                }).catch((error) => {
                    this.handleError(error);
                });

                const category = this.$services.Tagging.labels({
                    slug     : 'blog-category',
                    including: ['image', 'title', 'slug', 'url_encode'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const latestPost = this.$services.Content.postList({
                    type     : 'blog',
                    including: ['id', 'title', 'image', 'synopsis', 'published_at', 'tagging_labels:tags', 'url_encode', 'slug'],
                    limit    : 4,
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([posts, category, latestPost]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.setShow('List Wrapper - blog', responses[0].data.results.length);
                        this.setProp('List Wrapper - blog', { items: responses[0].data.results });
                        this.paginationModel = responses[0].data.metadata;
                    }

                    if (this.handleReq(responses, 1)) {
                        const items = responses[1].data.results.map((item) => ({
                            image: this.get(item, 'image.0'),
                            title: item.title,
                            to   : { name: 'blog-category', params: { url_encode: item.url_encode } },
                        }));
                        this.setShow('List Wrapper - category', responses[1].data.results.length);
                        this.setProp('List Wrapper - category', { items });
                    }

                    if (this.handleReq(responses, 2)) {
                        this.setShow('BlogCard Grid - latest', responses[2].data.results.length);
                        this.setProp('BlogCard Grid - latest', { items: responses[2].data.results });
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };

</script>
